import { render, staticRenderFns } from "./ClientListPage.vue?vue&type=template&id=2efebfb4&scoped=true"
import script from "./ClientListPage.vue?vue&type=script&lang=js"
export * from "./ClientListPage.vue?vue&type=script&lang=js"
import style0 from "./ClientListPage.vue?vue&type=style&index=0&id=2efebfb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efebfb4",
  null
  
)

export default component.exports